import { useQuery } from '@tanstack/react-query'
import { checkHealth } from '../services/healthApi'
import { FREQUENT } from '../utils/polling'

/**
 * The ONE query key for the API's health report. The Overview's KPI band and its System Health
 * panel both read it — one request, two readers — and the SignalR hub invalidates it by this
 * prefix.
 */
export const API_HEALTH_KEY = ['observatory', 'apiHealth'] as const

/**
 * `GET /api/health`, on FREQUENT: health drifts on the scale of a dependency going away, not a
 * job slot changing hands.
 *
 * A failed request is an ERROR here, never an Unhealthy report — see services/healthApi.ts. A
 * reader asks `isError` before `data`, because a refetch that fails keeps the previous report in
 * `data`, and that report is no longer what the API says.
 */
export function useApiHealth() {
  return useQuery({
    queryKey: API_HEALTH_KEY,
    queryFn: checkHealth,
    refetchInterval: FREQUENT,
  })
}
